import StarUsBanner from 'components/StarUsBanner'
import Banner2 from 'components/Banner2'
import ConversionInitiator from 'components/ConversionInitiator/landing.simple.tracking'
import CTA2 from './CTA2'
import Separator from 'components/Separator'
import React from 'react'
import Layout from '../Layout'
import { Hero4 } from './Hero4'
import { Hero3 } from 'components/Hero3'
import { Pillars } from './Pillars'
import NewsSlider from './NewsSlider'
import BlogsSlider from './BlogsSlider'
import { SEO } from 'components/seo'
import { SEO2 } from 'components/seo2'
import Approach from './Approach'
import HomeCTA from 'components/HomeCTA'
import ComponentBased from './ComponentBased'
import Hero2 from './Hero2'
import Community from './Community'
import Languages from './Languages'
import Customers2 from './Customers2'
import NotificationCenter from './NotificationCenter'
import SimpleUse from './SimpleUse'
import Features from './Features'
import CardSlider from './CardSlider'
import Customers from './Customers'
import Hero from './Hero'
import Pipelines from './Pipelines'
import Timeline from './Timeline'
import { section } from './classes'
import Blog from './Blog'
import Quote from './Quote'
import Tutorials from './Tutorials'
import useiCloudReady from '../../hooks/useiCloudReady'
import AllInOne from './AllInOne'
import Slider from './Slider'
import Enterprises from './Enterprises'
import Support from './Support'
import BeforeAndAfter from './BeforeAndAfter'
import CustomerData from './CustomerData'
import ProvenApproach from './ProvenApproach'
import HowTo from './HowTo'
import { SuperPowers, Levels } from './HowTo'
import Markets from './Markets'
import HomeMarkets2 from './Markets2'
import Apps from './Apps'
import { PricingCTA } from 'components/PricingCTA'
import { SignupCTA } from 'components/SignupCTA'
import { DemoCTA } from './Hero'
import { shortcodes } from '../../mdxGlobalComponents'
import { MDXProvider } from '@mdx-js/react'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import { StaticImage } from 'gatsby-plugin-image'
import { getSeoImage } from 'utils/googleData'

export const SectionWrapper = ({ children, className = '' }) => {
    return (
        <section className={`flex flex-col items-center justify-center ${className}`}>
            <div className="relative z-10 w-full">{children}</div>
        </section>
    )
}
export const CTAArrayWrapper = ({ children, className = '' }) => {
    return <div className={`flex flex-col items-center justify-center gap-2 md:flex-row ${className}`}>{children}</div>
}

export const SubSectionWrapper = ({ children, className = '' }) => {
    return <div className={`${section('relative z-10 md:!mb-8')} ${className}`}>{children}</div>
}

// export const Head = ({ location, params, data: { pageData, locales }, pageContext: { documentationNav } }) => {
//     return (
//         <SEO2
//             title={`iCloudReady - The complete Real estate platform`}
//             description={`iCloudReady is the all-in-one platform for building better products - with property management, real estate marketing, real estate crm, websites, mobile apps, and more.`}
//             image={`/images/home.png`}
//         />
//     )
// }
export default function Home(pageProps) {
    const { data, location, pageContext, params, children } = pageProps
    const { pageData, locales, documentation, tutorials, customers } = data
    const {
        body,
        excerpt,
        frontmatter,
        parent,
        fields: { slug },
    } = pageData?.nodes[0]
    const {
        title,
        subtitle,
        description,
        sidebar,
        pageStyle,
        darkMode,
        hideSurvey,
        enableStarUsBanner,
        faqs,
        enableStarUsBanner2,
        enableConversionInitiator,
        seoTitle,
        seoDescription,
        seoimage,
    } = frontmatter
    const components = {
        ...shortcodes(pageProps),
        HomeHero: (props: any) => <Hero {...props} {...pageProps} googleImages={[parent?.images, parent?.images2]} />,
        Hero4: (props: any) => <Hero4 {...props} {...pageProps} googleImages={[parent?.images, parent?.images2]} />,
        Hero3: (props: any) => <Hero3 {...props} googleImages={[parent?.images, parent?.images2]} />,
        Pillars: (props: any) => <Pillars {...props} googleImages={[parent?.images, parent?.images2]} />,
        NewsSlider: (props: any) => <NewsSlider {...props} googleImages={[parent?.images, parent?.images2]} />,
        BlogsSlider: (props: any) => <BlogsSlider {...props} googleImages={[parent?.images, parent?.images2]} />,
        SectionWrapper: (props: any) => <SectionWrapper {...props} googleImages={[parent?.images, parent?.images2]} />,
        SubSectionWrapper: (props: any) => (
            <SubSectionWrapper {...props} googleImages={[parent?.images, parent?.images2]} />
        ),
        CTAArrayWrapper: (props: any) => (
            <CTAArrayWrapper {...props} googleImages={[parent?.images, parent?.images2]} />
        ),
        PricingCTA: (props: any) => <PricingCTA {...props} googleImages={[parent?.images, parent?.images2]} />,
        SignupCTA: (props: any) => <SignupCTA {...props} googleImages={[parent?.images, parent?.images2]} />,
        DemoCTA: (props: any) => <DemoCTA {...props} googleImages={[parent?.images, parent?.images2]} />,
        Hero2: (props: any) => <Hero2 {...props} googleImages={[parent?.images, parent?.images2]} />,
        HomeCTA2: (props: any) => <CTA2 {...props} googleImages={[parent?.images, parent?.images2]} />,
        Features: (props: any) => (
            <Features {...props} {...pageProps} googleImages={[parent?.images, parent?.images2]} />
        ),
        NotificationCenter: (props: any) => (
            <NotificationCenter {...props} googleImages={[parent?.images, parent?.images2]} />
        ),
        Community: (props: any) => <Community {...props} googleImages={[parent?.images, parent?.images2]} />,
        ComponentBased: (props: any) => (
            <ComponentBased {...props} {...pageProps} googleImages={[parent?.images, parent?.images2]} />
        ),
        Customers2: (props: any) => <Customers2 {...props} googleImages={[parent?.images, parent?.images2]} />,
        SimpleUse: (props: any) => <SimpleUse {...props} googleImages={[parent?.images, parent?.images2]} />,
        Languages: (props: any) => <Languages {...props} googleImages={[parent?.images, parent?.images2]} />,
        ProductSlider: (props: any) => <Slider {...props} googleImages={[parent?.images, parent?.images2]} />,
        HomeMarkets3: (props: any) => <CardSlider {...props} googleImages={[parent?.images, parent?.images2]} />,
        Customers: (props: any) => <Customers {...props} googleImages={[parent?.images, parent?.images2]} />,
        AllInOne: (props: any) => <AllInOne {...props} googleImages={[parent?.images, parent?.images2]} />,
        Enterprises: (props: any) => <Enterprises {...props} googleImages={[parent?.images, parent?.images2]} />,
        HomeQuote: (props: any) => <Quote {...props} googleImages={[parent?.images, parent?.images2]} />,
        Support: (props: any) => <Support {...props} googleImages={[parent?.images, parent?.images2]} />,
        Timeline: (props: any) => <Timeline {...props} googleImages={[parent?.images, parent?.images2]} />,
        BeforeAndAfter: (props: any) => <BeforeAndAfter {...props} googleImages={[parent?.images, parent?.images2]} />,
        HomeApps: (props: any) => <Apps {...props} googleImages={[parent?.images, parent?.images2]} />,
        HomeMarkets: (props: any) => <Markets {...props} googleImages={[parent?.images, parent?.images2]} />,
        HomeMarkets2: (props: any) => <HomeMarkets2 {...props} googleImages={[parent?.images, parent?.images2]} />,
        Approach: (props: any) => <Approach {...props} googleImages={[parent?.images, parent?.images2]} />,
        Pipelines: (props: any) => <Pipelines {...props} googleImages={[parent?.images, parent?.images2]} />,
        CustomerData: (props: any) => <CustomerData {...props} googleImages={[parent?.images, parent?.images2]} />,
        ProvenApproach: (props: any) => <ProvenApproach {...props} googleImages={[parent?.images, parent?.images2]} />,
        HomeBlog: (props: any) => <Blog {...props} googleImages={[parent?.images, parent?.images2]} />,
        HomeTutorials: (props: any) => <Tutorials {...props} googleImages={[parent?.images, parent?.images2]} />,
        HomeCTA: (props: any) => <HomeCTA {...props} googleImages={[parent?.images, parent?.images2]} />,
        SuperPowers: (props: any) => <SuperPowers {...props} googleImages={[parent?.images, parent?.images2]} />,
        Levels: (props: any) => <Levels {...props} googleImages={[parent?.images, parent?.images2]} />,
        HowTo: (props: any) => <HowTo {...props} googleImages={[parent?.images, parent?.images2]} />,
    }
    useiCloudReady()
    // console.log('seoimage: ' + getSeoImage({ googleImages: [parent?.images, parent?.images2] }))
    return (
        <>
            {enableStarUsBanner && <StarUsBanner />}
            {enableStarUsBanner2 && <Banner2 />}
            {enableConversionInitiator && <ConversionInitiator />}
            <Layout>
                <SEO
                    title={seoTitle || `iCloudReady - The complete Real estate platform`}
                    description={
                        seoDescription ||
                        `iCloudReady is the all-in-one platform for building better products - with property management, real estate marketing, real estate crm, websites, mobile apps, and more.`
                    }
                    image={getSeoImage({ googleImages: [parent?.images, parent?.images2] }) || `/images/home.png`}
                />
                {/* <Separator backgroundColor="black" /> */}
                <MDXProvider components={components}>
                    <MDXRenderer>{body}</MDXRenderer>
                </MDXProvider>
            </Layout>
        </>
    )
}
